module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.a82383c1.eot";